import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Container, FormGroup } from "reactstrap";
import { useMeCore } from "../../../../../cores/me";
import { useIntl } from "react-intl";
import { useWebFormCore } from "../../../../../cores/webForm";
import { PanelWembii } from "../../../PanelWembii";
import { TitleWembii } from "../../../TitleWembii";
import { FORM_CONFIG } from "../../../../../cores/webForm/config";

export default function UrlForm() {
  const intl = useIntl();
  const { company } = useMeCore();
  const { webForm } = useWebFormCore();
  const domain = process.env.REACT_APP_EMBEDDED_FORM_DOMAIN;
  const [url, setUrl] = useState("");

  useEffect(() => {
    if (webForm.form) {
      setUrl(`${FORM_CONFIG.webUrl}/webform/${btoa(company?.id!)}/${btoa(webForm?.form!.id)}`);
    }
  }, [webForm, company, domain]);

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(url);
    toast.success(intl.formatMessage({ id: "app.editForm.instalationMsg" }));
  }, [url, intl]);

  const handleOpen = useCallback(() => {
    if (!url) return;
    window.open(url, "_blank", "noopener,noreferrer");
  }, [url]);

  return (
    <Container className="p-0">
      <PanelWembii shadow className="mb-4 p-4 web-form-editor-ai__card">
        <TitleWembii Tag="h5" color="primary">
          {intl.formatMessage({ id: "app.editForm.url" })}
        </TitleWembii>
        <FormGroup className="d-flex align-items-start justify-content-between mb-0 web-form-editor-ai__code-row">
          <pre className="d-flex flex-column p-2 web-form-editor-ai__code-box">
            {url}
          </pre>
          <div className="d-flex flex-shrink-0 web-form-editor-ai__code-actions">
            <button
              type="button"
              className="btn btn-sm web-form-editor-ai__copy-btn"
              id="copyCode"
              onClick={handleCopy}
            >
              {intl.formatMessage({ id: "app.editForm.instalationCopy" })}
            </button>
            <button
              type="button"
              className="btn btn-sm web-form-editor-ai__copy-btn"
              id="openUrl"
              disabled={!url}
              onClick={handleOpen}
            >
              {intl.formatMessage({ id: "app.editForm.urlOpen" })}
            </button>
          </div>
        </FormGroup>
      </PanelWembii>
    </Container>
  );
}
